import * as React from 'react'

/** Context for storing chat related data recieved from CA scripts
 * To preserve this value if case a child is re-rendered and this event might be lost
 * will be inital at the start and then will be updated as per data received from CA
 */

const ChatStatusContext = React.createContext({
  state: {},
  setState: {},
})

const ChatStatusProvider = (props) => {
  /**
   *  chatstates = 'initail'|'loading'|'preparing'|'offline'|'online'|'chatting'|'unavailable'
   *  'initial' -> inital state
   *  'loading' -> when component is loaded and GCP api is called
   *  'preparing' -> when gcp response is received and chat scripts are still being loaded
   *  'offline'|'online' -> Based on GCP response and response from CA received for agent availabilty
   *  'chatting' -> when chat is continued or window is opened
   *  'unavailable' -> when agents are unavailable
   */

  const [state, setState] = React.useState({
    chatStatus: 'initial',
    gcpChatStatus: false,
  })
  return (
    <ChatStatusContext.Provider
      value={{
        state,
        setState,
      }}
    >
      {props.children}
    </ChatStatusContext.Provider>
  )
}

export { ChatStatusContext, ChatStatusProvider }
